<template>
  <v-card>
    <v-card-title class="align-center justify-center primary white--text mb-4">Mettre à jour la date d'expiration du contrat</v-card-title>
    <v-card-text class="pa-0">
      <div class="d-flex flex-column mb-2">
        <div>
          <p><b>Date d'start du contrat:</b> {{ format(new Date(formattedValidityStart), 'dd/MM/yyyy') }} </p>
          <p><b>Date d'expiration du contrat:</b> {{ format(new Date(formattedValidityEnd), 'dd/MM/yyyy') }} </p>
        </div>
        <div class="d-flex flex-column mt-2 align-start">
          <div class="d-flex flex-shrink-0 align-center justify-center">
            <p class="mr-2 my-0"><b>Nouvelle date d'expiration du contrat:</b></p>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="newEndDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newEndDate"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
              <v-date-picker v-model="newEndDate" :min="minDate" no-title elevation="1">
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(newEndDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <v-col class="d-flex justify-center">
        <v-btn width="200" color="primary" :disabled="!newEndDate || !isDateValid" :loading="loading" @click="confirm">
          <span class="d-none d-sm-inline-block">Enregistrer</span>
        </v-btn>
      </v-col>
    </v-card-text>
  </v-card>
</template>
<script>
import { requests, EventBus } from '@/mixins/index';
import { format, isValid, isEqual, formatISO, endOfDay, getTime } from 'date-fns';
export default {
  components: { },
  mixins: [requests],
  props: {
    contract: {
      type: Object,
      default: () => {}
    },
    customer: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      newEndDate: null,
      loading: false,
      auxContract: this.$props.contract,
      menu: false
    };
  },
  mounted () {
    this.newEndDate = this.formattedValidityEnd;
  },
  computed: {
    minDate () {
      return format(new Date(), 'yyyy-MM-dd');
    },
    formattedValidityEnd () {
      return this.formatISODate(this.auxContract.validityEnd);
    },
    formattedValidityStart () {
      return this.formatISODate(this.auxContract.validityStart);
    },
    isDateValid () {
      if(!this.newEndDate || !this.formattedValidityEnd) return false;
      const newEndDateObject = new Date(this.newEndDate);
      const formattedValidityEndObject = new Date(this.formattedValidityEnd);
      if(!isValid(newEndDateObject) || !isValid(formattedValidityEndObject)) return false;
      return !isEqual(newEndDateObject, formattedValidityEndObject);
    }
  },
  methods: {
    format,
    formatISODate (date) {
      if(!date) return null;
      const dateObject = new Date(date.split('T')[0]);
      if(!isValid(dateObject)) return null;
      return format(dateObject, 'yyyy-MM-dd');
    },
    async confirm () {
      if (!this.newEndDate || !this.isDateValid) {
        return;
      }
      this.loading = true;
      const newEndDateUnixTime = getTime(endOfDay(new Date(this.newEndDate)));
      const response = await this.updateContractEndValidity(this.$props.customer.uuid, this.auxContract.contractNumber, newEndDateUnixTime, this.$store.state.user.uuid);
      this.loading = false;

      const notification = {
        message: response.success ? 'Mise à jour de la date d\'expiration du contrat réussie' : 'Erreur de mise à jour de la date d\'expiration du contrat',
        type: response.success ? 'success' : 'danger',
        timeout: 10000
      };
      EventBus.$emit('show-notifications', [notification]);

      if (response.success && response.data) {
        this.auxContract = { ...this.auxContract, validityEnd: formatISO(new Date(response.data.endTimestamp)) };
        EventBus.$emit('update-contract-validity', { ...this.auxContract });
        EventBus.$emit('up-to-date-contract-validity-history', false);
        this.newEndDate = this.formattedValidityEnd;
        this.menu = false;
      }
    }
  }
};
</script>


<style scoped>
  .date-picker-border-red {
    border: 1px solid red;
    border-radius: 1rem;
    padding: 0.5rem;
  }
</style>